export default "__VITE_ASSET__JR4L4P1q__"